import { fillVariants } from "../../../../styles/utils/fill"
import { classNames } from "../../../../utils"
import type { IconProps } from "../../../types"

export const CheckCircleFilled = ({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  innerFill = "white",
  innerFillAttribute = "white",
  ...rest
}: IconProps & {
  innerFill?: IconProps["fill"]
  innerFillAttribute?: IconProps["fillAttribute"]
}) => {
  return (
    <svg
      aria-label="Check Circle"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
      {innerFill !== "transparent" && (
        <path
          className={classNames(fillVariants({ fill: innerFill }))}
          d="m424 -296 282 -282 -56 -56 -226 226 -114 -114 -56 56 170 170Z"
          fill={innerFillAttribute}
        />
      )}
    </svg>
  )
}
